export default {
    setCaptchaEnabled(state, value) {
        state.captchaEnabled = value
    }
}